function updateRecommedationsSlider() {
  if (
    document.querySelector(".component--cart-drawer--recommendations__splide")
  ) {
    new Splide(".component--cart-drawer--recommendations__splide", {
      type: "loop",
      perPage: 1,
      pagination: false,
      arrows: true,
      autoWidth: false,
      width: "100%",
    }).mount();
  }
}
class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-drawer").updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-drawer-remove-button", CartDrawerRemoveButton);
class CartDrawerQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("cart-drawer-quantity-input", CartDrawerQuantityInput);
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.defaults = {
      cartModal: ".js-ajax-cart-modal",
      cartModalClose: ".js-ajax-cart-modal-close",
      cartDrawer: ".js-ajax-cart-drawer",
      cartDrawerContent: ".js-ajax-cart-drawer-content",
      cartDrawerClose: "[data-cart-drawer-close]",
      cartDrawerTrigger: "[data-cart-toggle]",
      cartOverlay: ".js-ajax-cart-overlay",
      cartCounter: "[data-cart-counter]",
      addToCart: ".js-ajax-add-to-cart",
      addBundleToCart: ".js-ajax-add-bundle-to-cart",
      bundleError: ".js-ajax-bundle-error",
      disabledBundleButton: ".js-ajax-disabled-bundle-button",
      removeFromCart: ".js-ajax-remove-from-cart",
      removeFromCartNoDot: "js-ajax-remove-from-cart",
      checkoutButton: ".js-ajax-checkout-button",
      bodyClass: "is-overlay-opened",
      mainContent: ".js-main-content",
      cartButtons: ".js-ajax-cart-buttons",
      cartSubtotal: ".js-ajax-cart-subtotal",
      cartHeader: ".js-ajax-cart-header",
      cartCollection: ".js-ajax-cart-collection",
      oneAddToCart: ".js-ajax-add-to-cart-one",
      addToCartButtons: "[data-product-add-to-cart]",
    };
    this.cartModal = document.querySelector(this.defaults.cartModal);
    this.cartModalClose = document.querySelector(this.defaults.cartModalClose);
    this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
    this.cartDrawerContent = document.querySelector(
      this.defaults.cartDrawerContent
    );
    this.cartDrawerClose = document.querySelectorAll(
      this.defaults.cartDrawerClose
    );
    this.cartDrawerTrigger = document.querySelector(
      this.defaults.cartDrawerTrigger
    );
    this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
    this.cartCounter = document.querySelector(this.defaults.cartCounter);
    this.addToCart = document.querySelectorAll(this.defaults.addToCart);
    this.addBundleToCart = document.querySelector(
      this.defaults.addBundleToCart
    );
    this.bundleError = document.querySelector(this.defaults.bundleError);
    this.disabledBundleButton = document.querySelectorAll(
      this.defaults.disabledBundleButton
    );
    this.removeFromCart = document.querySelectorAll(
      this.defaults.removeFromCart
    );
    this.checkoutButton = document.querySelector(this.defaults.checkoutButton);
    this.htmlSelector = document.documentElement;
    this.mainContent = document.querySelector(this.defaults.mainContent);
    this.cartButtons = document.querySelector(this.defaults.cartButtons);
    this.cartSubtotal = document.querySelector(this.defaults.cartSubtotal);
    this.cartHeader = document.querySelector(this.defaults.cartHeader);
    this.cartCollection = document.querySelector(this.defaults.cartCollection);
    this.oneAddToCart = document.querySelectorAll(this.defaults.oneAddToCart);
    this.addToCartButtons = document.querySelectorAll(
      this.defaults.addToCartButtons
    );
    this.bindEvents();
    this.updateGiftProduct.bind(this);
    this.giftwrapping = document.querySelector("cart-drawer-gifting");
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    /*this.querySelector(".js-ajax-cart-drawer-content").addEventListener(
      "change",
      this.debouncedOnChange.bind(this)
    );*/
    /*this.querySelectorAll(
      ".component--cart-drawer--line-item__container"
    ).forEach((item) => {
      item.addEventListener("change", this.debouncedOnChange.bind(this));
    });*/


  }
  bindEvents() {
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 100);
    this.querySelectorAll(
      ".component--cart-drawer--line-item__container"
    ).forEach((item) => {
      item.addEventListener("change", this.debouncedOnChange.bind(this));
    });
    document
      .querySelector("[data-cart-toggle]")
      .addEventListener("click", this.openCart.bind(this));
    document
      .querySelectorAll("[data-cart-drawer-close]")
      .forEach((item) =>
        item.addEventListener("click", this.closeCart.bind(this))
      );
    this.cartOverlay.addEventListener("click", () => {
      this.closeFailModal();
      this.closeCartDrawer();
      this.closeCartOverlay();
    });
  }
  updateCart() {
    fetch(
      `/?sections=${this.getSectionsToRender().map((section) => section.id)}`
    )
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach((section) => {
          document.getElementById(section.selector).innerHTML =
            this.getSectionInnerHTML(parsedState[section.id], section.selector);
        });
        this.bindEvents();
        updateRecommedationsSlider();
        this.addDiscount();
        this.openCart();
      });
  }
  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
    );
  }
  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.selector).innerHTML =
        this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
    });
    this.bindEvents();
    updateRecommedationsSlider();
    this.openCart();
  }
  getSectionsToRender() {
    return [
      {
        id: "global--cart-drawer--products",
        selector: `component--cart-drawer--items`,
      },
      {
        id: "global--cart-drawer--icon",
        selector: `global--cart-drawer--icon`,
      },
      {
        id: "global--cart-drawer--footer",
        selector: `global--cart-drawer--footer`,
      },
      {
        id: "global--cart-drawer--recommendations",
        selector: `component--cart-drawer--recommendations`,
      },
    ];
  }
  getSectionInnerHTML(html, selector) {
    const h = new DOMParser().parseFromString(html, "text/html");
    return h.getElementById(selector).innerHTML;
  }
  addDiscount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const isFreeShipping = cart.items.filter(
          (item) => item.selling_plan_allocation && item.original_line_price > 1000
        );
        if (document.querySelector(".component--cart-drawer--footer__button")) {
          if (isFreeShipping.length > 0) {
            document
              .querySelector(".component--cart-drawer--footer__button")
              .setAttribute("href", "/checkout?discount=FREESHIPPING");
          } else {
            document
              .querySelector(".component--cart-drawer--footer__button")
              .setAttribute("href", "/checkout/");
          }
        }
      });
  }
  /*hasGifting(data) {
    if (data) {
      const isGifting = data.items.filter((item) => item.id == 42930506825883);
      if (isGifting.length > 0) {
        const itemInCart = data.item_count - isGifting[0].quantity;
        this.giftwrapping.updateGift(itemInCart);
      } else {
        this.updateCart();
      }
    } else {
      if (
        JSON.parse(
          document
            .querySelector(".component--cart-drawer--gifting")
            .getAttribute("data-gift-wraps-in-cart")
        ) > 0
      ) {
        const count =
          JSON.parse(
            document
              .querySelector(".component--cart-drawer--gifting")
              .getAttribute("data-items-in-cart")
          ) + 1;
        this.giftwrapping.updateGift(count);
      } else {
        this.updateCart();
      }
    }
  }*/
  updateQuantity(line, quantity) {
    const body = JSON.stringify({
      line,
      quantity,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.updateGiftProduct(parsedState);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  updateGiftProduct(cart) {
    let count = 0;
    if (cart.items.length > 0) {
      const items = cart.items.filter(
        (item) => item.properties["gift-wrap"] == "Yes"
      );
      if (items.length > 0) {
        let sum = 0;
        items.forEach((item) => {
          if(!giftProducts.includes(item.handle)){
            sum += item.quantity;
          }
        });
        count = sum;
      } else {
      }
    }
    if (document.querySelector(".component--cart-drawer--gifting")) {
      const giftId = document
        .querySelector(".component--cart-drawer--gifting")
        .getAttribute("data-gift-id");
      var headers = new Headers({ "Content-Type": "application/json" });
      var request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          updates: { [giftId]: count },
        }),
      };
      fetch("/cart/update.js", request).then(() => {
        this.updateCart();
      });
    } else {
      this.updateCart();
    }
  }
  openCart() {
    this.openCartDrawer();
    this.openCartOverlay();
  }
  openCartDrawer() {
    this.cartDrawer.classList.add("ajax-cart--open");
  }
  closeCartDrawer() {
    this.cartDrawer.classList.remove("ajax-cart--open");
  }
  clearCartDrawer() {
    this.cartDrawerContent.innerHTML = "";
  }
  closeCart() {
    this.closeCartDrawer();
    this.closeCartOverlay();
  }
  openCartOverlay() {
    document.body.classList.add("is-overlay-opened");
    this.cartOverlay.style.opacity = 0.4;
    this.cartOverlay.style.display = "block";
    this.cartOverlay.style.visibility = "visible";
  }
  closeCartOverlay() {
    document.body.classList.remove("is-overlay-opened");
    this.cartOverlay.style.opacity = 0;
    this.cartOverlay.style.display = "none";
    this.cartOverlay.style.visibility = "hidden";
  }
  currentCartItemNumber(cart) {
    this.cartCounter.innerHTML = cart.item_count;
    if (cart.item_count > 0) {
      this.cartButtons.style.display = "block";
    } else {
      this.cartButtons.style.display = "none";
    }
  }
  addToCartOk() {
    this.fetchAndOpenCart();
  }
  fetchAndOpenCart() {
    this.fetchCart(() => {
      this.openCartDrawer();
      this.openCartOverlay();
    });
  }
  ajaxRequestFail() {
    this.openFailModal();
    this.openCartOverlay();
  }
  openFailModal() {
    this.cartModal.style.opacity = 0.4;
    this.cartModal.style.display = "block";
    this.cartModal.style.visibility = "visible";
  }
  openFailModal() {
    this.cartModal.style.opacity = 0.4;
    this.cartModal.style.display = "block";
    this.cartModal.style.visibility = "visible";
  }
  closeFailModal() {
    this.cartModal.style.opacity = 0;
    this.cartModal.style.display = "none";
    this.cartModal.style.visibility = "hidden";
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-drawer");
  }
  updateRecommedationsSlider() {
    new Splide(".component--cart-drawer--recommendations__splide", {
      type: "loop",
      perPage: 1,
      pagination: false,
      arrows: true,
      autoWidth: false,
      width: "100%",
    }).mount();
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);
    
    const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.text())
      .then((state) => {
        //const parsedState = JSON.parse(state);
        //this.cart.hasGifting();
        this.cart.updateCart();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.removeAttribute("disabled");
      });
  }
}
customElements.define("cart-drawer-product-form", CartDrawerProductForm);
class CartDrawerItemGifting extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-drawer");
    this.id = this.getAttribute("data-line");
    this.quantity = this.getAttribute("data-quantity");
    /*
    this.giftId = this.getAttribute("data-gift-id");
    this.isGifting = document.querySelectorAll(
      '[name="properties[gift-wrap]"]'
    );
    */
    this.giftNote = document.querySelectorAll('[name="properties[gift-note]"]');
    /*this.giftId = JSON.parse(this.getAttribute("data-gift-id"));
    this.itemCount = document
      .querySelector(".component--cart-drawer--gifting")
      .getAttribute("data-cart-item-count");
    this.giftWrapsInCart = JSON.parse(
      document
        .querySelector(".component--cart-drawer--gifting")
        .getAttribute("data-gift-wraps-in-cart")
    );
    this.itemsInCart = JSON.parse(
      document
        .querySelector(".component--cart-drawer--gifting")
        .getAttribute("data-items-in-cart")
    );
    this.cartAttributesGiftWrapping = document
      .querySelector(".component--cart-drawer--gifting")
      .getAttribute("data-cart-attributes-gift-wrapping");*/
    this.bindEvents();
    /*
    this.setGift.bind(this);
    this.removeGift.bind(this);
    */
    //this.hideGiftProductFromCart();
  }
  bindEvents() {
    /*
    this.querySelectorAll(".component--cart-drawer--gifting__wrapping--input")
      .forEach((item) => {
        item.addEventListener("change", this.toggleGift.bind(this));
      });
    */
    this.querySelectorAll(".component--cart-drawer--gifting__note--input")
      .forEach((item) => {
        item.addEventListener("change", this.addGiftNote.bind(this));
      });
  }
  /*
  update(count) {
    if (this.itemCount == 1 && this.giftWrapsInCart > 0) {
      this.updateGift(count);
    } else if (
      this.giftWrapsInCart > 0 &&
      this.giftWrapsInCart != this.itemsInCart
    ) {
      this.setGift();
    } else if (
      this.giftWrapsInCart > 0 &&
      this.cartAttributesGiftWrapping == ""
    ) {
      this.setGift();
    } else if (
      this.giftWrapsInCart == 0 &&
      this.cartAttributesGiftWrapping != ""
    ) {
      this.setGift();
    }
  }
  hideGiftProductFromCart() {
    document.querySelectorAll(".cart-item").forEach((item) => {
      const id = item.getAttribute("data-variant-id");
      const giftId = document
        .querySelector(".component--cart-drawer--gifting")
        .getAttribute("data-gift-id");
      if (id == giftId) {
        item.style.display = "none";
      }
    });
  }
  */
  /*updateGift(count) {
    var headers = new Headers({ "Content-Type": "application/json" });
    var request = {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        updates: { [this.giftId]: count },
        attributes: { "gift-wrapping": true },
      }),
    };
    fetch("/cart/update.js", request).then(() => {
      this.cart.updateCart();
    });
  }*/
  /*
  setGift(evt) {
    const variantId = this.dataset.variantId;
    const line = this.dataset.line;
    const key = this.dataset.key;
    const quantity = this.dataset.quantity;
    const props = this.dataset.properties.replace(/"{"/g, '{"').replace(/"}"/g, '"}').replace(/=>/g, ':');
    const properties = {
      ...JSON.parse(props),
      "gift-wrap": "Yes",
      "gift-note": ""
    }

    if(properties._bundle_selection){
      this.reAddItem(key, line, variantId, quantity, properties, true)
      return;
    }

    const headers = {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    }
    var request = {
      method: "POST",
      credentials: 'same-origin',
      headers: headers,
      body: JSON.stringify({
        'line': line,
        'quantity': quantity,
        'properties': properties
      })
    };

    fetch("/cart/change.js", request)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        this.cart.updateGiftProduct(json);
      })
      .catch((e) => {
        console.error(e);
      });
  }
  */
  async reAddItem(key, line, variantId, quantity, properties){
    const removeRequest = {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      body: JSON.stringify({
        'id': key,
        'quantity': 0,
      })
    };

    await fetch("/cart/change.js", removeRequest)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
      })
      .catch((e) => {
        console.error(e);
      });

    const addRequest = {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      body: JSON.stringify({
        'items': [
          {
            'quantity': quantity,
            'id': variantId,
            'properties': properties
          }
        ]
      })
    };

    fetch("/cart/add.js", addRequest)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        this.cart.updateCart();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  /*
  removeGift(evt) {
    const variantId = this.dataset.variantId;
    const line = this.dataset.line;
    const key = this.dataset.key;
    const quantity = this.dataset.quantity;
    const props = this.dataset.properties.replace(/"{"/g, '{"').replace(/"}"/g, '"}').replace(/=>/g, ':');
    const properties = {
      ...JSON.parse(props),
      "gift-wrap": "No",
      "gift-note": ""
    }

    if(properties._bundle_selection){
      this.reAddItem(key, line, variantId, quantity, properties, true)
      return;
    }

    const headers = {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    }
    var request = {
      method: "POST",
      credentials: 'same-origin',
      headers: headers,
      body: JSON.stringify({
        'line': line,
        'quantity': quantity,
        'properties': properties
      })
    };
    fetch("/cart/change.js", request)
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.cart.updateGiftProduct(parsedState);
      })
      .catch((e) => {
        console.error(e);
      });
  }
  */
  addGiftNote(evt) {
    evt.preventDefault();
    var note = evt.target.value;
    const variantId = this.dataset.variantId;
    const line = this.dataset.line;
    const key = this.dataset.key;
    const props = this.dataset.properties.replace(/"{"/g, '{"').replace(/"}"/g, '"}').replace(/=>/g, ':');
    const properties = JSON.parse(props);
    properties["gift-note"] = note;

    if(properties._bundle_selection){
      this.reAddItem(key, line, variantId, quantity, properties)
      return;
    }

    const headers = {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    }
    var request = {
      method: "POST",
      credentials: 'same-origin',
      headers: headers,
      body: JSON.stringify({
        'id': key,
        'properties': properties
      })
    };

    fetch("/cart/change.js", request)
      .then((response) => response.text())
      .then((state) => {
        this.cart.updateCart();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  /*
  toggleGift(evt) {
    evt.preventDefault();
    if (evt.target.checked) {
      this.setGift(evt);
    } else {
      this.removeGift(evt);
    }
  }
  */
}
customElements.define("cart-drawer-item-gifting", CartDrawerItemGifting);

class CartDrawerGSToggle extends HTMLElement {
  constructor() {
    super();
    this.checkbox = document.querySelector("#gs__toggle-shipping");
    this.checkoutButton = document.querySelector(".component--cart-drawer--footer__button");
    this.checkoutButton.addEventListener("click", (event) => {
      if(this.checkbox.checked){
        event.preventDefault();
        window.location.href = "/a/gs/cart/";
      }
    });
    this.checkbox.addEventListener("change", () => {
      if(this.checkbox.checked){
        this.checkoutButton.classList.add("disabled");
        console.log("disabled");
        this.addAttribute();
        console.log("added attribute");
        this.checkoutButton.classList.remove("disabled");
        console.log("enabled");
      } else {
        this.checkoutButton.classList.add("disabled");
        console.log("disabled");
        this.removeAttribute();
        console.log("removed attribute");
        this.checkoutButton.classList.remove("disabled");
        console.log("enabled");
      }
    });
  }
  async removeAttribute() {
    const updateRequest = {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      body: JSON.stringify({
        attributes: {
          'multiship': ''
        }
      })
    }; 

    await fetch("/cart/update.js", updateRequest)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
      })
      .catch((e) => {
        console.error(e);
      });
  }
  async addAttribute() {
    const updateRequest = {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      body: JSON.stringify({
        attributes: {
          'multiship': true
        }
      })
    }; 

    await fetch("/cart/update.js", updateRequest)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("cart-drawer-gs-toggle", CartDrawerGSToggle);
